var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.sent
      ? _c("div", {}, [
          !_vm.client.comoMembership
            ? _c(
                "div",
                {
                  staticClass:
                    "flex-between-center mob-flex-column p-10 border-dashed-grey1 radius-5",
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "flex-shrink-0 text-regular bg-color1 bg-hover-color2 color-white radius-5 py-8 px-10 fsize-14 flex-start-center border-0",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.register()
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v("Activer le compte fidélité")]),
                      _vm._v(" "),
                      _vm.sending
                        ? _c("i", {
                            staticClass: "fa fa-spinner fa-lg fa-pulse",
                          })
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            : _c(
                "div",
                {
                  staticClass:
                    "flex-between-center mob-flex-column p-10 border-dashed-grey1 radius-5",
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "flex-shrink-0 text-regular bg-color1 bg-hover-color2 color-white radius-5 py-8 px-10 fsize-14 flex-start-center border-0",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.sendCode()
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v("Activez votre compte")]),
                      _vm._v(" "),
                      _vm.sending
                        ? _c("i", {
                            staticClass: "fa fa-spinner fa-lg fa-pulse",
                          })
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.sent
      ? _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.confirmCode()
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "flex-start-center p-10 border-dashed-grey1 radius-5",
              },
              [
                _c("div", { staticClass: "has-float-label" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.code,
                        expression: "code",
                      },
                    ],
                    staticClass: "form-item fsize-18 text-bold",
                    attrs: { id: "code", placeholder: " ", type: "tel" },
                    domProps: { value: _vm.code },
                    on: {
                      focus: function ($event) {
                        _vm.onFocus = true
                      },
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.code = $event.target.value
                        },
                        function ($event) {
                          _vm.errorMsg = ""
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "mob-fsize-14 mob-pt-5 color-grey4",
                      attrs: { for: "code" },
                    },
                    [_vm._v("Insérer le code reçu par SMS")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "small",
                    class: [
                      _vm.onFocus == false || _vm.code == ""
                        ? "btnFlat-grey2"
                        : "btnFlat-ok",
                    ],
                    attrs: {
                      disabled: _vm.onFocus == false || _vm.code == "",
                      tyoe: "submit",
                    },
                  },
                  [
                    _c("span", [_vm._v("Vérifier")]),
                    _vm.processing
                      ? _c("i", {
                          staticClass: "fa fa-spinner fa-lg fa-pulse ml-5",
                        })
                      : _vm._e(),
                  ]
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.errorMsg
      ? _c("div", { staticClass: "flex-between-center my-10" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errorMsg,
                  expression: "errorMsg",
                },
              ],
              staticClass: "color-ko mx-10 text-italic fsize-12 text-bold",
            },
            [_vm._v(_vm._s(_vm.errorMsg))]
          ),
          _vm._v(" "),
          _vm.errorMsg
            ? _c("div", { staticClass: "flex-start-center" }, [
                _c(
                  "div",
                  {
                    staticClass: "link-ko hover-color1",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.close()
                      },
                    },
                  },
                  [_vm._v("Annuler")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "mx-10" }, [_vm._v("ou")]),
                _vm._v(" "),
                !_vm.client.comoMembership
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "text-regular bg-color1 bg-hover-color2 color-white radius-5 py-8 px-10 fsize-14 flex-start-center border-0",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            _vm.register()
                            _vm.errorMsg = ""
                          },
                        },
                      },
                      [
                        _c("span", [_vm._v("Renvoyer un code ?")]),
                        _vm._v(" "),
                        _vm.sending
                          ? _c("i", {
                              staticClass: "fa fa-spinner fa-lg fa-pulse",
                            })
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.client.comoMembership
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "text-regular bg-color1 bg-hover-color2 color-white radius-5 py-8 px-10 fsize-14 flex-start-center border-0",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            _vm.sendCode()
                            _vm.errorMsg = ""
                          },
                        },
                      },
                      [
                        _c("span", [_vm._v("Renvoyer un code ?")]),
                        _vm._v(" "),
                        _vm.sending
                          ? _c("i", {
                              staticClass: "fa fa-spinner fa-lg fa-pulse",
                            })
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mr-20" }, [
      _c("div", { staticClass: "text-bold mob-text-center" }, [
        _vm._v("Pas encore membre ?"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-10 mob-text-center" }, [
        _vm._v(
          "Inscrivez-vous pour commencer à recevoir des offres et récompenses !"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mr-20" }, [
      _c("div", { staticClass: "text-bold mob-text-center" }, [
        _vm._v("Déjà membre ?"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-10 mob-text-center" }, [
        _vm._v("Connectez-vous pour accéder à vos points de fidélité."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }